import * as types from '../actions/types';

const initState = {
    loading: false,
    loaded: false
};

export default function ConstantsReducer (state = initState, action) {
    switch (action.type) {

        case types.CONSTANTS_LOAD:
            return {...initState, loading: true, loaded: false };

        case types.CONSTANTS_LOAD_SUCCESS:
            const { codes, phone } = action.payload;
            const CZE = codes.states.find((element) => element.key === 'CZE');
            const SVK = codes.states.find((element) => element.key === 'SVK');
            let states = codes.states.filter((element) => element.key !== 'CZE' && element.key !== 'SVK');
            states.unshift(CZE,SVK);

            const PHONE_CZE = phone.find((element) => element.value === '+420');
            const PHONE_SVK = phone.find((element) => element.value === '+421');
            let phones = phone.filter((element) => element.value !== '+420' && element.value !== '+421');
            phones.unshift(PHONE_CZE, PHONE_SVK);

            return {
                ...state,
                phone: phones,
                codes: {
                    ...codes,
                    states
                },
                loading: false,
                loaded: true
            };

        case types.CONSTANTS_LOAD_ERROR:
            return {...initState, loading: false, loaded: false };

        default:
            return state;
    }
}
